<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/surveys/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/surveys/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Вопросы',
                        url: `/surveys/${this.$route.params.id}/questions`,
                    },
                    {
                        title: 'Результаты',
                        url: `/surveys/${this.$route.params.id}/results`,
                    },
                ],
            };
        },
    };
</script>
